/**
 * @author Vivek Kumar <vivek.kumar@314ecorp.com>
 * @description Component for displaying the outstanding patient responsibility amount with contextual styling.
 */
import React from 'react';
import _ from 'lodash';
import { Typography } from 'antd';

import { formatAmount } from 'utils/accounts/allAccounts';
import { EMPTY_VALUE } from '@veritable/common/constants';

export interface OutstandingPRTagProps {
	value?: unknown;
}

const OutstandingPRTag: React.FC<OutstandingPRTagProps> = ({ value }) => {
	const numericValue = _.toNumber(value);
	const formattedAmount = formatAmount(numericValue) ?? EMPTY_VALUE;
	const textType = numericValue > 0 ? 'warning' : 'success';

	return (
		<Typography.Text type={textType}>
			{'Outstanding PR: '}
			{formattedAmount}
		</Typography.Text>
	);
};

export default OutstandingPRTag;
